<template>
  <v-dialog
    v-model="show"
    max-width="630px"
    scrollable
    @click:outside="close"
  >
    <component
      :is="customComponent"
      v-bind="{
        formTitle,
        customVars,
        isLocked: isLendingStrategyLocked,
        isLoading,
      }"
      @cancel="close"
      @submit="handleSubmit"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import ClarityRiskExposedConfig from './components/ClarityRiskExposedConfig.vue';
import ClarityRiskExposedV1V2Config from './components/ClarityRiskExposedV1V2Config.vue';
import ExposedRiskRecencyPrefilter from './components/ExposedRiskRecencyPrefilter.vue';
import ScoringModelSequenceElementForm from './components/ScoringModelSequenceElementForm.vue';

export default {
  name: 'ScoringModelSequenceElementModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    elementData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      customVars: {},
      isLoading: true,
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    formTitle() {
      return this.elementData && this.elementData.class && this.elementData.method
        ? `${this.elementData.class}→${this.elementData.method}`
        : '';
    },

    isLendingStrategyLocked() {
      return this.elementData && this.elementData.isLendingStrategyLocked;
    },

    customComponent() {
      const componentMap = {
        'clarity:riskExposed': ClarityRiskExposedConfig,
        'clarity:riskExposedV1V2': ClarityRiskExposedV1V2Config,
        'recencyPrefilter:scanRecencyPrefilterExposed': ExposedRiskRecencyPrefilter,
      };

      const { class: className, method } = this.elementData || {};
      return componentMap[`${className}:${method}`] || ScoringModelSequenceElementForm;
    },
  },

  watch: {
    elementData: {
      immediate: true,
      handler() {
        if (this.elementData && this.elementData.scoringModelId) {
          this.fetch();
        }
      },
    },
  },

  methods: {
    ...mapActions('notification', ['setNotification']),

    close() {
      this.$emit('close-modal');
    },

    async fetch() {
      this.isLoading = true;
      this.customVars = {};

      try {
        const endpoint = `/api/v1/scoring-model/${this.elementData.scoringModelId}/sequence/get-route-custom-vars/${this.elementData.id}`;
        const { data } = await this.$axios.get(endpoint);
        this.customVars = data.custom_vars || {};
      } catch (error) {
        console.error('Error fetching customVars:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async handleSubmit(payload) {
      console.log('Submitting:', payload);

      try {
        const endpoint = `/api/v1/scoring-model/${this.elementData.scoringModelId}/sequence/update-route-custom-vars/${this.elementData.id}`;
        const { data } = await this.$axios.put(endpoint, payload);

        this.$emit('setCustomVars', data.custom_vars);
        this.setNotification({
          message: data.message || 'Configuration updated successfully.',
          color: 'green',
        });
      } catch (error) {
        console.error('Submission error:', error);
        this.setNotification({
          message: 'There was an error processing your request.',
          color: 'red',
        });
      } finally {
        this.close();
      }
    },
  },
};
</script>
